export interface BatchForcedReturnRequest {
  lendDateFrom: string
  lendDateTo: string
  dueDateFrom: string
  dueDateTo: string
  branchCode: string
  branchType: string
  isChangeUserStatus: boolean
  isUpdate: boolean
  collectionStatus: string
  isRemove: boolean
  removeReason: string
  batchType: string
}

export function BatchForcedReturnRequestToJSON(
  value: BatchForcedReturnRequest
): any {
  return {
    lend_date_from: value.lendDateFrom,
    lend_date_to: value.lendDateTo,
    due_date_from: value.dueDateFrom,
    due_date_to: value.dueDateTo,
    branch_code: value.branchCode,
    branch_type: value.branchType,
    is_change_user_status: value.isChangeUserStatus,
    is_update: value.isUpdate,
    collection_status: value.collectionStatus,
    is_remove: value.isRemove,
    remove_reason: value.removeReason,
    batch_type: value.batchType
  }
}
